import { Directive, Input, TemplateRef } from '@angular/core';
import { WrapPanelVisibility, WrapPanelWidth } from '@fleet-beat/wrap-panel';

@Directive({
  selector: '[fbWrapPanelItem]',
})
export class WrapPanelItemDirective<T> {
  @Input() fbWrapPanelItem: string | WrapPanelWidth;

  @Input() fbWrapPanelItemVisibility: WrapPanelVisibility = WrapPanelVisibility.Visible;

  constructor(public templateRef: TemplateRef<T>) {}
}
